
import { supabase } from '../client';

/**
 * Create a link between a score and a game in the score_games junction table
 */
export const createScoreGameLink = async (scoreId: string, gameId: string) => {
  const { error } = await supabase
    .from('score_games')
    .insert({ score_id: scoreId, game_id: gameId });
    
  if (error) {
    console.error('Error creating score game link:', error);
    return false;
  }
  
  return true;
};

/**
 * Get all game IDs associated with a score
 */
export const getScoreGames = async (scoreId: string): Promise<string[]> => {
  const { data, error } = await supabase
    .from('score_games')
    .select('game_id')
    .eq('score_id', scoreId);
    
  if (error) {
    console.error('Error fetching score games:', error);
    return [];
  }
  
  return data?.map(item => item.game_id) || [];
};

/**
 * Get all score IDs associated with a game
 * Renamed from getGameScores to getGameScoreIds to avoid naming conflict
 */
export const getGameScoreIds = async (gameId: string): Promise<string[]> => {
  const { data, error } = await supabase
    .from('score_games')
    .select('score_id')
    .eq('game_id', gameId);
    
  if (error) {
    console.error('Error fetching game scores:', error);
    return [];
  }
  
  return data?.map(item => item.score_id) || [];
};

/**
 * Delete a score-game link
 */
export const deleteScoreGameLink = async (scoreId: string, gameId: string) => {
  const { error } = await supabase
    .from('score_games')
    .delete()
    .eq('score_id', scoreId)
    .eq('game_id', gameId);
    
  if (error) {
    console.error('Error deleting score game link:', error);
    return false;
  }
  
  return true;
};
